import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { MaterialFormStackModule } from '@zerops/zerops/core/material-form-stack';
import { ZefFormFieldModule } from '@zerops/zef/forms/modules';
import { UserDataEnvFormatDialogContainer } from './user-data-env-format-dialog.container';
import { UserDataEnvFormatDialogTranslationsModule } from './user-data-env-format-dialog.translations';

@NgModule({
  declarations: [ UserDataEnvFormatDialogContainer ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialFormStackModule,
    ZefFormFieldModule,
    MatButtonModule,
    MatIconModule,
    ZefDialogModule,
    UserDataEnvFormatDialogTranslationsModule
  ],
  exports: [ UserDataEnvFormatDialogContainer ]
})
export class UserDataEnvFormatDialogModule {

}
